<template>
    <content-view>
        <!-- 积分管理－基础设置页面 -->
        <div class="wrap-container-in">
            <a-form :form="form" class="integral" @submit="handleSubmit" >
                <div class="block-title">会员积分生效设置</div>
                <a-form-item >
                    <a-radio-group name="pointEffectiveOption" v-decorator="['pointEffectiveOption',{initialValue: '1'}]" :disabled="disabled">
                        <a-radio :style="radioStyle" :value="'1'">消费后立即生效</a-radio>
                        <a-radio :style="radioStyle" :value="'2'">消费后 <a-input-number placeholder="请输入" :min="0" v-decorator="['pointEffectiveHour']" :disabled="disabled" /> 小时生效</a-radio>
                    </a-radio-group>
                </a-form-item>
                <div class="line"></div>
                <div class="block-title">会员积分过期设置</div>
                <a-form-item >
                    <a-radio-group name="radioGroup" @change="onChangeVipOver" v-decorator="['pointExpirationOption',{initialValue: '1'}]" :disabled="disabled">
                        <a-radio :style="radioStyle" :value="'1'">始终有效，不过期</a-radio>
                        <a-radio :style="radioStyle" :value="'2'">每 <a-input-number placeholder="请输入" :min="0" v-decorator="['intervalYear']" :disabled="disabled" /> 年
                            <a-select placeholder="请选择" v-decorator="['month', {initialValue: month}]" :disabled="disabled">
                                <a-select-option :value="item" v-for="item in 12" :key="item" >{{item}}</a-select-option>
                            </a-select> 月
                            <a-select placeholder="请选择" v-decorator="['day', {initialValue: day}]" :disabled="disabled">
                                <a-select-option :value="item" v-for="item in 31" :key="item" >{{item}}</a-select-option>
                            </a-select> 日，清零之前的积分
                        </a-radio>
                        <div class="message-box" v-if="showVipOver">
                            <a-checkbox v-decorator="['pointZeroSmsOption', {valuePropName: 'checked'}]" :disabled="disabled" >清零之前短信提示</a-checkbox>
                            <a class="text-primary" @click="visible=true" v-if="!disabled">短信内容设置</a>
                            <span class="text-disabled" v-else>短信内容设置</span>
                        </div>
                        <a-modal title="短信内容" v-model="visible" @ok="handleOk" >
                            <a-textarea placeholder="请输入短信内容" :rows="4"  v-decorator="['pointZeroSmsMsg']" />
                        </a-modal>
                    </a-radio-group>
                </a-form-item>
                <div class="line"></div>
                <div class="block-title">会员积分兑换规则</div>
                <a-form-item >
                    每消费 <a-input-number placeholder="请输入" :min="0" v-decorator="['pointExchangeAmount']" :disabled="disabled" />
                    元兑换 <a-input-number placeholder="请输入" :min="0" v-decorator="['pointExchangeNum']" :disabled="disabled" /> 积分
                </a-form-item>
                <div class="line"></div>
                <div class="block-title">餐饮 - 会员积分抵扣规则</div>
                <a-form-item >
                    <a-checkbox v-decorator="['repastDeductionRule.pointOption', {valuePropName: 'checked'}]" :disabled="disabled">交易时，积分可抵扣订单金额，每一积分兑换  </a-checkbox>
                    <a-input-number placeholder="请输入" :min="0" v-decorator="['repastDeductionRule.pointAmount']" :disabled="disabled" /> 元，抵扣比例最多为
                    <a-input-number placeholder="请输入" :min="0" v-decorator="['repastDeductionRule.pointPercent']" :disabled="disabled" /> ％
                    <br />
                    <a-checkbox v-decorator="['repastDeductionRule.couponMeanwhileOption', {valuePropName: 'checked'}]" :disabled="disabled">消费时可与优惠券同时使用</a-checkbox>
                    <br />
                    <a-checkbox v-decorator="['repastDeductionRule.payAuthOption', {valuePropName: 'checked'}]" :disabled="disabled" >为保证资产安全，积分支付功能仅限实名认证用户使用</a-checkbox>
                    <br />
                    <a-checkbox v-decorator="['repastDeductionRule.memberPriceOption', {valuePropName: 'checked'}]" :disabled="disabled" >对餐饮类商品进行会员价设置，会员价为原价的：  </a-checkbox>
                    <a-input-number placeholder="请输入" :min="0" v-decorator="['repastDeductionRule.memberPricePercent']" :disabled="disabled"/> ％
                </a-form-item>
                <div class="line"></div>
                <div class="block-title">购票 - 会员积分抵扣规则</div>
                <a-form-item >
                    <a-checkbox v-decorator="['ticketDeductionRule.pointOption', {valuePropName: 'checked'}]" :disabled="disabled">交易时，积分可抵扣订单金额，每一积分兑换  </a-checkbox>
                    <a-input-number placeholder="请输入" :min="0" v-decorator="['ticketDeductionRule.pointAmount']" :disabled="disabled" /> 元，抵扣比例最多为
                    <a-input-number placeholder="请输入" :min="0" v-decorator="['ticketDeductionRule.pointPercent']" :disabled="disabled" /> ％
                    <br />
                    <a-checkbox v-decorator="['ticketDeductionRule.couponMeanwhileOption', {valuePropName: 'checked'}]" :disabled="disabled">消费时可与优惠券同时使用</a-checkbox>
                    <br />
                    <a-checkbox v-decorator="['ticketDeductionRule.payAuthOption', {valuePropName: 'checked'}]" :disabled="disabled">为保证资产安全，积分支付功能仅限实名认证用户使用</a-checkbox>
                    <br />
                    <a-checkbox v-decorator="['ticketDeductionRule.memberPriceOption', {valuePropName: 'checked'}]" :disabled="disabled">对门票/课程票类商品进行会员价设置，会员价为原价的：  </a-checkbox>
                    <a-input-number placeholder="请输入" :min="0" v-decorator="['ticketDeductionRule.memberPricePercent']" :disabled="disabled" /> ％
                </a-form-item>
                <div class="line"></div>
                <div class="block-title">零售商品 - 会员积分抵扣规则</div>
                <a-form-item >
                    <a-checkbox v-decorator="['retailDeductionRule.pointOption', {valuePropName: 'checked'}]" :disabled="disabled">交易时，积分可抵扣订单金额，每一积分兑换  </a-checkbox>
                    <a-input-number placeholder="请输入" :min="0" v-decorator="['retailDeductionRule.pointAmount']" :disabled="disabled" /> 元，抵扣比例最多为
                    <a-input-number placeholder="请输入" :min="0" v-decorator="['retailDeductionRule.pointPercent']" :disabled="disabled" /> ％
                    <br />
                    <a-checkbox v-decorator="['retailDeductionRule.couponMeanwhileOption', {valuePropName: 'checked'}]" :disabled="disabled" >消费时可与优惠券同时使用</a-checkbox>
                    <br />
                    <a-checkbox v-decorator="['retailDeductionRule.payAuthOption', {valuePropName: 'checked'}]" :disabled="disabled" >为保证资产安全，积分支付功能仅限实名认证用户使用</a-checkbox>
                    <br />
                    <a-checkbox v-decorator="['retailDeductionRule.memberPriceOption', {valuePropName: 'checked'}]" :disabled="disabled" >对门票/课程票类商品进行会员价设置，会员价为原价的：  </a-checkbox>
                    <a-input-number placeholder="请输入" :min="0" v-decorator="['retailDeductionRule.memberPricePercent']" :disabled="disabled" /> ％
                </a-form-item>
                <div class="line"></div>
                <div class="block-title">会员进行积分时间设定</div>
                <a-form-item >
                    开启时效：在
                    <a-date-picker
                        v-decorator="['pointTimeLimit']"
                        format="YYYY-MM-DD HH:mm:ss"
                        :disabled="disabled"
                        :disabledDate="disabledDate"
                        :showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                        /> 后生效
                </a-form-item>
                <div class="text-center" v-if="getBtnByAuth('basicsSetUpdate')">
                    <a-button type="primary" @click="disabled = false" v-if="disabled" >编辑</a-button>
                    <a-button type="primary" html-type="submit" v-else >开启系统</a-button>
                </div>
            </a-form>
        </div>
    </content-view>
</template>

<script type="text/javascript">
import moment  from 'moment';
export default {
    name: "basicsSet",
    components: {},
    props: {},
    data() {
        return {
            radioStyle: {
                display: 'block',
                height: '32px',
                lineHeight: '32px',
            },
            showVipOver: false,
            visible: false,
            disabled: true,
            month: 1,
            day: 1,
            pointExpirationDate: ''
        };
    },
    computed: {},
    methods: {
        moment,
        getMemberPoint() {
            this.$api.integral.memberPoint().then(res => {
                this.pointExpirationDate = res.pointExpirationDate
                this.month = res.pointExpirationOption == '2' ? Number(this.pointExpirationDate.split('-')[0]) : 1
                this.day = res.pointExpirationOption == '2' ? Number(this.pointExpirationDate.split('-')[1]) : 1
                res.pointZeroSmsOption = res.pointZeroSmsOption == '1' ? true : false
                this.showVipOver = res.pointExpirationOption == '2' ? true : false
                delete res.pointExpirationDate
                res.pointTimeLimit = moment(res.pointTimeLimit, 'YYYY-MM-DD HH:mm:00')
                this.$nextTick(() => {
                    this.form.setFieldsValue(res)
                })
            })
        },
        handleSubmit (e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (!err) {
                    values.pointZeroSmsOption = values.pointZeroSmsOption ? '1' : '0'
                    values.pointTimeLimit = values.pointTimeLimit.format('YYYY-MM-DD HH:mm:00')
                    values.pointExpirationDate = values.month + '-' + values.day
                    this.$api.integral.updateMemberPoint(
                        {body: values}
                    ).then(res => {
                        this.$message.success('操作成功', 2);
                        this.disabled = true
                    });
                }
            });
        },
         range(start, end) {
            const result = [];
            for (let i = start; i < end; i++) {
                result.push(i);
            }
            return result;
        },
        disabledDate(current) {
            return current < moment().startOf('day');
        },
        onChangeVipOver(e) {
            this.showVipOver = e.target.value == 2 ? true : false
        },
        handleOk() {
            this.visible = false
        },
    },
    beforeCreate() {
        this.form = this.$form.createForm(this);
    },
    created() {},
    mounted() {
        this.getMemberPoint()
    },
};
</script>
<style lang="scss" scoped>
    .wrap-container-in {
        background-color: #fff;
        padding: 24px 32px;
        border-radius: 2px;
        .integral {
            .block-title {
                font-size: 16px;
                line-height: 32px;
                font-weight: 900;
                color: rgba(0, 0, 0, 0.85);
            }
            .line {
                border-top: 1px solid #e8e8e8;
                padding-top: 16px;
                margin-top: 16px;
            }
            .message-box {
                margin-left: 42px;
                line-height: 40px;
            }
            .ant-select {
                width: 80px;
            }
            .ant-calendar-picker {
                width: 200px;
            }
        }
    }
</style>
